import React from "react";
import {
  SwitchProps,
  matchPath,
  useLocation,
  useRouteMatch
} from "react-router";

import { toNestRoute } from "./Route";
import { Nesting } from "./types";

// React-Router's Switch (like this one) works by inspecting the path props of
// its children.  This is great, except that our special Nest Routes don't
// have the full path in their props - they calculate it at runtime and pass
// it down to a real Route.  From the Switch's perspective, it's just a path
// fragment that doesn't match.  Therefore, to get Switch to work with Nest
// Routes, we have to re-implement it and special case the Nest scenario.
export const Switch: React.FC<SwitchProps & Nesting> = props => {
  const contextLocation = useLocation();
  const contextMatch = useRouteMatch();
  const location = props.location || contextLocation;
  let element, match: React.ReactNode;
  let nest = props.nest;

  React.Children.forEach(props.children, child => {
    if (match == null && React.isValidElement(child)) {
      element = child;
      const nestChild = nest || child?.props?.nest;
      // If this is a nested route, calculate the nested path in the same way PRoute does.
      const path = nestChild
        ? toNestRoute(contextMatch.path)(child.props.path || child.props.from)
        : child.props.path || child.props.from;
      match = path
        ? matchPath(location.pathname, { ...child.props, path })
        : contextMatch;
    }
  });

  return match && element
    ? React.cloneElement(element, {
        location,
        computedMatch: match,
        computedNest: nest
      })
    : null;
};
